import FetchRequest from "@/api/FetchRequest";

class ttsOpenApi {
    //基础url
    static url = "/ai/subtitle/";
    // 详情
    static getTtsState( textId: string,ttsStatus:number): Promise<any> {

        return FetchRequest.post(this.url + 'text/tts/'+textId +'?ttsStatus='+ttsStatus,'', true);
    }
    // 倍速
    static putTtsSpeed( textId: string,id:number,ttsStatus:number,speed:number): Promise<any> {

        return FetchRequest.put(this.url + 'text/tts/'+textId +'?id='+id+'&ttsStatus='+ttsStatus+'&speed='+speed,'', true);
    }
    // 重新生成
    static reTtsDubbing( textId: string,ttsStatus:number,id:string): Promise<any> {
        return FetchRequest.post(this.url + 'text/tts/regenerate/'+textId +'?ttsStatus='+ttsStatus+'&id='+id,'', true);
    }
}

export default ttsOpenApi;